(function () {
  'use strict';

  // ═══════ PATCH Dawn CartDrawerItems to skip cart-icon-bubble re-render ═══════
  // Dawn's default section-rendering throws when it can't find `.shopify-section`
  // inside our custom #cart-icon-bubble anchor. Skip it — we manage bag count separately.
  function patchCartDrawerItems() {
    var def = customElements.get && customElements.get('cart-drawer-items');
    if (!def) return setTimeout(patchCartDrawerItems, 50);
    def.prototype.getSectionsToRender = function () {
      return [{ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' }];
    };
  }
  patchCartDrawerItems();

  // Hide the Dawn error region whenever the cart changes — any render hiccup
  // (e.g. skipped section) shouldn't surface a scary message to the user.
  document.addEventListener('click', function (e) {
    var isQty = e.target.closest && e.target.closest('.bellascena-cart__qty-btn, cart-remove-button, [data-upsell-add]');
    if (!isQty) return;
    setTimeout(function () {
      var err = document.getElementById('CartDrawer-CartErrors');
      if (err) err.textContent = '';
    }, 600);
    // Also refresh our own bag count bubble after a cart mutation
    setTimeout(refreshBagCount, 700);
  });

  function refreshBagCount() {
    // Ook hier de markt-prefix: /cart.js zonder prefix leest de winkelwagen
    // van de standaardmarkt.
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;
        document.querySelectorAll('#cart-icon-bubble').forEach(function (el) {
          var bubble = el.querySelector('.bellascena-header__bag-count');
          if (count > 0) {
            if (bubble) {
              bubble.textContent = count;
            } else {
              bubble = document.createElement('span');
              bubble.className = 'bellascena-header__bag-count';
              bubble.setAttribute('aria-live', 'polite');
              bubble.textContent = count;
              el.appendChild(bubble);
            }
          } else if (bubble) {
            bubble.remove();
          }
        });
      })
      .catch(function () {});
  }

  // ═══════ Body scroll lock when drawer opens / unlock on close ═══════
  var scrollY = 0;
  function lockScroll() {
    // Al op slot? Dan niets opnieuw meten: window.scrollY is dan 0 en dat zou
    // de bewaarde positie overschrijven.
    if (document.body.style.position === 'fixed') return;
    scrollY = window.scrollY;
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }
  function unlockScroll() {
    document.documentElement.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  }
  // Observe cart-drawer class changes
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    var wasActive = false;
    new MutationObserver(function () {
      var isActive = cartDrawer.classList.contains('active');
      if (isActive && !wasActive) lockScroll();
      if (!isActive && wasActive) unlockScroll();
      wasActive = isActive;
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  // ═══════ MOBILE CART ICON — open drawer ═══════
  document.querySelectorAll('.cart-icon-bubble-mobile').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.open(el);
    });
  });

  // ═══════ UPSELL ADD-TO-CART ═══════
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-upsell-add]');
    if (!addBtn) return;

    e.preventDefault();
    var variantId = addBtn.dataset.upsellAdd;
    addBtn.textContent = '...';
    addBtn.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        // Re-render the cart drawer via section rendering
        return fetch(window.Shopify.routes.root + 'cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cartData) {
        // Fetch the updated cart drawer HTML
        return fetch(window.location.pathname + '?section_id=cart-drawer');
      })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // Update cart drawer content
        var newInner = doc.querySelector('.drawer__inner');
        var currentInner = document.querySelector('.drawer__inner');
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
        }

        // Update cart icon bubble
        return fetch(window.location.pathname + '?section_id=cart-icon-bubble');
      })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newBubble = doc.querySelector('.shopify-section');
        var currentBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }

        // Remove is-empty class
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.remove('is-empty');
      })
      .catch(function (err) {
        console.error('Upsell add failed:', err);
        addBtn.textContent = '+';
        addBtn.disabled = false;
      });
  });

  // ═══════ DRAWER VERVERSEN VAN BUITENAF ═══════
  // Het keuzepaneel (bellascena-quick-add.js) voegt zelf toe en roept dit aan.
  // Dezelfde twee verzoeken als hierboven, maar dan zonder knop-afhandeling —
  // zo staat de verversing op één plek in plaats van in elk script opnieuw.
  window.bellascenaRefreshCartDrawer = function () {
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newInner = doc.querySelector('.drawer__inner');
        var currentInner = document.querySelector('.drawer__inner');
        if (newInner && currentInner) currentInner.innerHTML = newInner.innerHTML;
        return fetch(window.location.pathname + '?section_id=cart-icon-bubble');
      })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newBubble = doc.querySelector('.shopify-section');
        var currentBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.remove('is-empty');
      })
      .catch(function (err) { console.error('Cart refresh failed:', err); });
  };

  // ═══════ PDP CART DRAWER OPEN ═══════
  // Listen for the custom cart:refresh event from bellascena-pdp.js
  document.addEventListener('cart:refresh', function () {
    // Fetch updated cart drawer and re-render
    fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newInner = doc.querySelector('.drawer__inner');
        var currentInner = document.querySelector('.drawer__inner');
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
        }

        // Update cart icon
        return fetch(window.location.pathname + '?section_id=cart-icon-bubble');
      })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newBubble = doc.querySelector('.shopify-section');
        var currentBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }

        // Open the drawer
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          drawer.classList.remove('is-empty');
          drawer.open();
        }
      })
      .catch(function (err) { console.error('Cart refresh failed:', err); });
  });
})();
